import { FC } from 'react';
import { useDoWithdraw } from './WithdrawForm';
import { WithdrawPanel } from './WithdrawPanel';

export const WithdrawPanelController: FC = () => {
  const doWithdraw = useDoWithdraw();

  return <WithdrawPanel doWithdraw={doWithdraw} />;
};
